import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { AccountPage } from '~/src/features/account/pages/AccountPage'
import { CartPage } from '~/src/features/cart/pages/CartPage'
import { CatalogPage } from '~/src/features/catalog/pages/CatalogPage'
// import { ProductPage } from '~/src/features/catalog/pages/ProductPage'
import { CheckoutPage } from '~/src/features/checkout/pages/CheckoutPage'
import { OrderPage } from '~/src/features/orders/pages/OrderPage'

export function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<CatalogPage />} />
      {/*<Route path="/producto/:slug" element={<ProductPage />} />*/}
      <Route path="/carrito" element={<CartPage />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/cuenta" element={<AccountPage />} />
      <Route path="/pedido/:number" element={<OrderPage />} />
    </Routes>
  )
}
